import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const processService = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Service identifier'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .meta({ format: 'capitalCase' })
      .describe('Human-readable label'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    properties: hasMany('ProcessServiceProperty', 'serviceId'),
  })
  .describe('An external service that a process can invoke via a Service Task.')
  .as('ProcessService');

export { processService as processServiceSchema };
